import React, { useState, useEffect, useRef } from 'react';
import { RedoOutlined, UploadOutlined } from '@ant-design/icons';
import styles from './MarketPlace.module.css';
import * as apiUrl from '../../api/index';
import { getToken } from '../../common/auth';
import {
    Button,
    Card,
    Col,
    Divider,
    Form,
    Input,
    Image,
    message,
    Modal,
    Popconfirm,
    Radio,
    Row,
    Select,
    Space,
    Spin,
    Table,
    Typography,
    Upload,
} from 'antd';
import { SIZE, ANTD_TEXT, ERROR_MSG, ANTD_DIVIDER, ANTD_BUTTON, ANTD_SPACE, COMMON_STRING, FAV_ICON_PRE_URL } from '../Helper/Constant';
import {
    getMarketPlaceInitData,
    validateMarketPlace,
    searchMarketPlace,
    getPermissionByConnectedApps,
    searchSaasApp,
    addMarketPlace,
    modifyPermission,
    connectedAppsWithoutPermissions,
    modifyConnectedApps,
    saveEditConnectedApp,
    updateRiskLevels,
    checkLogo,
} from './MarketPlace.service';
import {
    PermissionRiskLevels,
    MarketPlaceDataTypes,
    MarketPlaceAllowRoles,
    MarketPlaceStrings,
    FormFieldRules,
    ConnectedAppFields,
} from './MarketPlaceConstant';

const { TextArea, Search } = Input;
const { Option } = Select;
const { Text, Paragraph } = Typography;

let CategoryList = [];
let PermissionList = [];
const ALLOWEDROLE = MarketPlaceAllowRoles;
let ROLE = null;

const MarketPlaceUI = (props) => {
    ROLE = props.user.role;
    const rule = [{ required: true, message: MarketPlaceStrings.RULE_MSG }];
    const [loading, setLoading] = useState(true);
    const [marketPlaceOption, setMarketPlaceOption] = useState([]);
    const [selMarketPlace, setSelMarketPlace] = useState(null);
    useEffect(() => {
        getMarketPlaceInitData().then((res) => {
            if (res) {
                setMarketPlaceOption(
                    res.marketPlaces.map((marketPlace) => ({
                        label: marketPlace.marketplace_name,
                        value: marketPlace.marketplace_name,
                    }))
                );
                CategoryList = res.categories.map((category) => ({
                    label: category.category_name,
                    value: category.category_id,
                }));
                PermissionList = res.permissions;
            } else {
                message.error(ERROR_MSG.GENERAL_ERROR);
            }
            setLoading(false);
        });
    }, []);

    const onSelectMarketPlace = ({ target: { value } }) => {
        setSelMarketPlace(null);
        setTimeout(() => {
            setSelMarketPlace(value);
        }, 100);
    };

    return (
        <div className={styles.main_body}>
            {loading ? (
                <Spin></Spin>
            ) : (
                <div className={styles.main_div}>
                    <Card title={MarketPlaceStrings.MARKET_PLACE_CARD_TITLE} size={SIZE.SMALL} className="ns-card-border-radius">
                        <Radio.Group
                            key={'market'}
                            options={marketPlaceOption}
                            onChange={onSelectMarketPlace}
                            optionType="button"
                            buttonStyle="solid"
                        />
                    </Card>
                    {selMarketPlace ? (
                        <>
                            <SearchEntry marketPlace={selMarketPlace} />
                            <ConnectedApps rule={rule} marketPlace={selMarketPlace} />
                            {ALLOWEDROLE.includes(ROLE) ? <Permission rule={rule} marketPlace={selMarketPlace} /> : ''}
                        </>
                    ) : (
                        ''
                    )}
                </div>
            )}
        </div>
    );
};

const SearchEntry = (props) => {
    const connectedAppsTableCol = [
        { title: 'Id', dataIndex: 'id', key: 'id', width: '2%' },
        // { title: 'App Name', dataIndex: 'connected_app_name', key: 'connected_app_name', width: '8%' },
        {
            title: 'App Name',
            dataIndex: 'display_name',
            key: 'display_name',
            width: '15%',
            render: (text, record) => (
                <div className="ns-flex_space-between">
                    <Space direction={'vertical'} size={0}>
                        <Text>{text}</Text>
                        <Text type={'secondary'}>{record.connected_app_name}</Text>
                    </Space>
                    <Space direction={'horizontal'}>
                        <Image height={50} src={'data:image/jpeg;base64,' + record?.ConnectedAppLogo?.app_logo} preview={false} />
                        <Image
                            width={35}
                            height={35}
                            src={'data:image/jpeg;base64,' + record?.ConnectedAppLogo?.fav_icon_logo}
                            preview={false}
                        />
                    </Space>
                </div>
            ),
        },
        { title: 'Publisher Name', dataIndex: 'publisher_name', key: 'publisher_name', width: '8%' },
        { title: 'Publisher Url', dataIndex: 'publisher_url', key: 'publisher_url', width: '20%' },
        {
            title: 'Action',
            dataIndex: 'id',
            key: 'action',
            width: '10%',
            render: (id, record) => (
                <Space size={4}>
                    <Button
                        type={ANTD_BUTTON.TYPE_LINK}
                        onClick={() => {
                            setConnectedApp(record);
                            openModal(modalTypes.assignPermission.key);
                        }}
                    >
                        Permissions
                    </Button>
                    <Button
                        type={ANTD_BUTTON.TYPE_LINK}
                        onClick={() => {
                            setConnectedApp(record);
                            openModal(modalTypes.editApp.key);
                        }}
                    >
                        Edit
                    </Button>
                    {ALLOWEDROLE.includes(ROLE) ? (
                        <Popconfirm
                            title="Are you sure to delete this app?"
                            onConfirm={() => onConfirmDeleteApp(id)}
                            okText="Yes"
                            cancelText="No"
                        >
                            <Button type={ANTD_BUTTON.TYPE_LINK} danger>
                                Delete
                            </Button>
                        </Popconfirm>
                    ) : null}
                </Space>
            ),
        },
    ];

    const modalTypes = {
        assignPermission: { key: 'assignPermission', title: MarketPlaceStrings.PERMISSION_MODAL_TITLE },
        editApp: { key: 'editApp', title: MarketPlaceStrings.EDIT_APP_MODAL_TITLE },
    };

    const defaultModalValue = {
        ...modalTypes.assignPermission,
        open: false,
    };

    const [searchLoading, setSearchLoading] = useState(false);
    const [tableLoading, setTableLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [modalValue, setModalValue] = useState(defaultModalValue);
    const [connectedApp, setConnectedApp] = useState(null);

    const onSearch = async (searchText) => {
        if (!searchText || searchText.length === 0) {
            message.info(MarketPlaceStrings.SEARCH_EMPTY);
            return;
        }
        setSearchLoading(true);
        await searchMarketPlace(searchText, props.marketPlace, MarketPlaceDataTypes.connectedApps.key).then((res) => {
            setTableData(
                res.map((row) => {
                    return { key: row.id, ...row };
                })
            );
        });
        setSearchLoading(false);
    };

    const openModal = (modalType) => {
        if (modalType === modalTypes.assignPermission.key) {
            setModalValue({ ...modalTypes.assignPermission, open: true });
        }
        if (modalType === modalTypes.editApp.key) {
            setModalValue({ ...modalTypes.editApp, open: true });
        }
    };

    const onModalClose = () => {
        setModalValue({ defaultModalValue });
        setConnectedApp(null);
    };

    const onClickWithoutPermission = async () => {
        setTableLoading(true);
        await connectedAppsWithoutPermissions(props.marketPlace).then((res) => {
            setTableData(
                res.map((row) => {
                    return { key: row.id, ...row };
                })
            );
        });
        setTableLoading(false);
    };

    const onConfirmDeleteApp = async (connected_app_id) => {
        await modifyConnectedApps(connected_app_id, 'delete').then((res) => {
            if (res) {
                message.success(MarketPlaceStrings.SUCCESS_DELETE_APP_MSG);
                setTableData(tableData.filter((row) => row.id != connected_app_id));
            }
        });
    };

    const updateRiskLevelForAllApps = async () => {
        updateRiskLevels().then((res) => {
            if (res === 0) {
                message.info(MarketPlaceStrings.NO_APPS_FOR_RISK_LEVEL);
            } else if (res > 0) {
                message.success('Updating risk level for ' + res + ' this will take time.');
            } else {
                message.error(ERROR_MSG.GENERAL_ERROR);
            }
        });
    };

    const onCheckLogo = async () => {
        checkLogo(props.marketPlace).then((res) => {});
    };

    const searchBox = (
        <Space size={8}>
            <Button onClick={onCheckLogo} shape={ANTD_BUTTON.SHAPE_ROUND} size={SIZE.SMALL} type={ANTD_BUTTON.TYPE_PRIMARY}>
                Check Logo
            </Button>
            <Button onClick={onClickWithoutPermission} shape={ANTD_BUTTON.SHAPE_ROUND} size={SIZE.SMALL} type={ANTD_BUTTON.TYPE_PRIMARY}>
                Unassigned Permission Apps
            </Button>
            <Button onClick={updateRiskLevelForAllApps} shape={ANTD_BUTTON.SHAPE_ROUND} size={SIZE.SMALL} type={ANTD_BUTTON.TYPE_PRIMARY}>
                Update Risk Level
            </Button>
            <Search
                className="ns-width-large"
                placeholder="Search App / Publisher name"
                enterButton="Search"
                size={SIZE.SMALL}
                onSearch={onSearch}
                allowClear
                loading={searchLoading}
            />
        </Space>
    );
    return (
        <Card title={MarketPlaceStrings.SEARCH_APP_CARD_TITLE} size={SIZE.SMALL} extra={searchBox} className="ns-card-border-radius">
            <Table
                size={SIZE.SMALL}
                key={'search_table'}
                columns={connectedAppsTableCol}
                dataSource={tableData}
                scroll={{ y: 400 }}
                pagination={false}
                loading={tableLoading}
            />
            <Modal title={modalValue.title} open={modalValue.open} onCancel={onModalClose} footer={null} width={'80%'} destroyOnClose>
                {modalValue.key === modalTypes.assignPermission.key ? (
                    <AssignPermissionModal connectedApp={connectedApp} marketPlace={props.marketPlace} />
                ) : null}
                {modalValue.key === modalTypes.editApp.key ? (
                    <EditConnectedAppModal marketPlace={props.marketPlace} connectedApp={connectedApp} />
                ) : null}
            </Modal>
        </Card>
    );
};

const ConnectedApps = (props) => {
    const intiFormValues = {
        fav_icon_logo_url: FAV_ICON_PRE_URL,
    };
    const [form] = Form.useForm();
    const [disableForm, setDisableForm] = useState(false);
    const [popUpOpen, setPopUpOpen] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [addedApp, setAddedApp] = useState(null);
    const [modalPermissionOpen, setModalPermissionOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);

    const onFinish = (values) => {
        if (values?.saas_appid) {
            if (!(!isNaN(parseFloat(values?.saas_appid)) && isFinite(values?.saas_appid))) {
                message.info(MarketPlaceStrings.SAAS_ID_NUMBER);
                return;
            }
        }
        setLoading(true);
        validateMarketPlace(values, props.marketPlace, MarketPlaceDataTypes.connectedApps.key).then((res) => {
            if (res) {
                setDisableForm(true);
                setPopUpOpen(true);
            }
            setLoading(false);
        });
    };

    const onPopUpConfirm = () => {
        setConfirmLoading(true);
        setDisableForm(false);
        const values = form.getFieldsValue(true);
        values.marketplace_name = props.marketPlace;
        addMarketPlace(values, MarketPlaceDataTypes.connectedApps.key)
            .then((res) => {
                if (res) {
                    setAddedApp(res);
                    setPopUpOpen(false);
                    message.success(MarketPlaceStrings.SUCCESS_CONNECTED_APP);
                }
                setConfirmLoading(false);
            })
            .finally(() => {
                setConfirmLoading(false);
            });
    };

    const onModalClose = () => {
        setModalOpen(false);
    };

    const onModalPermissionClose = () => {
        setModalPermissionOpen(false);
    };

    const onSelectSaasApp = (appId) => {
        form.setFieldValue('saas_appid', appId);
        onModalClose();
    };

    const resetForm = () => {
        form.resetFields();
        setAddedApp(null);
    };

    const cardExtraAction = <RedoOutlined className="ns-cursor-pointer" onClick={resetForm} />;

    return (
        <Card
            title={MarketPlaceStrings.CONNECTED_APP_CARD_TITLE}
            size={SIZE.SMALL}
            className="ns-card-border-radius"
            extra={cardExtraAction}
        >
            <Form
                name="connected_apps"
                form={form}
                onFinish={onFinish}
                autoComplete="off"
                disabled={disableForm}
                size={SIZE.SMALL}
                initialValues={intiFormValues}
            >
                <ConnectedAppsFormFields form={form} rule={FormFieldRules.default} marketPlace={props.marketPlace} />
                <div className="ns-margin-top">
                    <Button type={ANTD_BUTTON.TYPE_PRIMARY} htmlType="submit" size={SIZE.SMALL} loading={loading}>
                        Add Connected Apps
                    </Button>
                    {addedApp ? (
                        <Button
                            className="ns-margin-left"
                            type={ANTD_BUTTON.TYPE_PRIMARY}
                            size={SIZE.SMALL}
                            onClick={() => setModalPermissionOpen(true)}
                        >
                            Assign Permission
                        </Button>
                    ) : null}
                </div>
            </Form>
            <Popconfirm
                title={'Are you sure to add entry in ' + props.marketPlace}
                open={popUpOpen}
                okText="Yes"
                cancelText="No"
                okButtonProps={{ loading: confirmLoading }}
                onConfirm={onPopUpConfirm}
                onCancel={() => {
                    setPopUpOpen(false);
                    setDisableForm(false);
                }}
            ></Popconfirm>
            <Modal
                title={MarketPlaceStrings.SEARCH_SAAS_MODAL_TITLE}
                open={modalOpen}
                onCancel={onModalClose}
                footer={null}
                width={'80%'}
                destroyOnClose
            >
                <SearchSaasApp onSelectSaasApp={onSelectSaasApp} />
            </Modal>
            <Modal
                title={addedApp?.connected_app_name ? 'Permissions -> ' + addedApp?.connected_app_name : 'Permissions'}
                open={modalPermissionOpen}
                onCancel={onModalPermissionClose}
                footer={null}
                width={'80%'}
                destroyOnClose
            >
                <AssignPermissionModal connectedApp={addedApp} marketPlace={props.marketPlace} />
            </Modal>
        </Card>
    );
};

const Permission = (props) => {
    const rule = props.rule;
    const catSelProp = {
        options: PermissionRiskLevels.map((riskLevel) => {
            return { label: riskLevel, value: riskLevel };
        }),
        style: { minWidth: '300px' },
    };

    const [form] = Form.useForm();
    const [popUpOpen, setPopUpOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const onFinish = (values) => {
        setLoading(true);
        validateMarketPlace(values, props.marketPlace, MarketPlaceDataTypes.permission.key).then((res) => {
            if (res) {
                setPopUpOpen(true);
            }
            setLoading(false);
        });
    };

    const onPopUpConfirm = () => {
        const values = form.getFieldsValue(true);
        values.marketplace_name = props.marketPlace;
        addMarketPlace(values, MarketPlaceDataTypes.permission.key).then((res) => {
            if (res) {
                onPopUpCancel();
                message.success(MarketPlaceStrings.SUCCESS_PERMISSION);
                getMarketPlaceInitData().then((res) => {
                    if (res) PermissionList = res.permissions;
                });
            }
        });
    };

    const onPopUpCancel = () => {
        setPopUpOpen(false);
    };

    const resetForm = () => {
        form.resetFields();
    };
    const cardExtraAction = <RedoOutlined className="ns-cursor-pointer" onClick={resetForm} />;

    return (
        <Card title={MarketPlaceStrings.PERMISSION_CARD_TITLE} size={SIZE.SMALL} className="ns-card-border-radius" extra={cardExtraAction}>
            <Form name="permission " form={form} onFinish={onFinish} autoComplete="off">
                <Row gutter={[16, 0]} align="middle">
                    <Col span={6}>
                        <DividerComponent text={'Group Name'} />
                        <Form.Item name="group_name" rules={rule}>
                            <Input className="ns-width-full" size={SIZE.SMALL} />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <DividerComponent text={'Permission Name'} />
                        <Form.Item name="permission_name" rules={rule}>
                            <Input size={SIZE.SMALL} className="ns-width-full" />
                        </Form.Item>
                    </Col>
                    <Col>
                        <DividerComponent text={'Risk Level'} />
                        <Form.Item name="risk_level" rules={rule}>
                            <Select size={SIZE.SMALL} {...catSelProp}></Select>
                        </Form.Item>
                    </Col>
                    <Col>
                        <Popconfirm
                            title={'Are you sure to add "Permissions" for ' + props.marketPlace + ' Market Place'}
                            open={popUpOpen}
                            okText="Yes"
                            cancelText="No"
                            onConfirm={onPopUpConfirm}
                            onCancel={onPopUpCancel}
                        ></Popconfirm>
                        <Button type={ANTD_BUTTON.TYPE_PRIMARY} htmlType="submit" size={SIZE.SMALL} loading={loading}>
                            {MarketPlaceStrings.ADD_PERMISSION_BUTTON}
                        </Button>
                    </Col>
                </Row>
            </Form>
        </Card>
    );
};

const AssignPermissionModal = (props) => {
    const catSelProp = {
        showSearch: true,
        optionFilterProp: 'label',
        filterOption: (input, option) => option?.label?.toLowerCase().indexOf(input.toLowerCase()) >= 0,
        filterSort: (optionA, optionB) => optionA?.label?.toLowerCase().localeCompare(optionB?.label?.toLowerCase()),
        style: { minWidth: '300px' },
    };

    const [loading, setLoading] = useState(true);
    const [tableData, setTableData] = useState([]);
    const [options, setOptions] = useState([]);
    const [selPermissionId, setSelPermissionId] = useState(null);

    const permissionHistoryCol = [
        { title: 'Permission Id', dataIndex: 'id', key: 'id', width: '8%' },
        { title: 'Market Place', dataIndex: 'marketplace_name', key: 'marketplace_name', width: '10%' },
        { title: 'Group Name', dataIndex: 'group_name', key: 'group_name', width: '15%' },
        { title: 'Permission', dataIndex: 'permission_name', key: 'permission_name' },
        { title: 'Risk Level', dataIndex: 'risk_level', key: 'risk_level', width: '8%' },
        {
            title: 'Action',
            dataIndex: 'id',
            key: 'action',
            width: '8%',
            render: (id) => (
                <Popconfirm title="Are you sure to delete?" onConfirm={() => deletePermission(id)} okText="Yes" cancelText="No">
                    <Button type={ANTD_BUTTON.TYPE_LINK}>Delete</Button>
                </Popconfirm>
            ),
        },
    ];

    const fetchPermissions = () => {
        setLoading(true);
        getPermissionByConnectedApps(props.connectedApp.id).then((res) => {
            setLoading(false);
            let permissionIds = [];
            const permissions = res.map((row) => {
                permissionIds.push(row.permission_id);
                return { key: row.permission_id, ...row.Permission };
            });
            setOptions(
                PermissionList.map((permission) => {
                    if (permission.marketplace_name === props.marketPlace) {
                        if (!permissionIds.includes(permission.id)) {
                            return { label: permission.permission_name, value: permission.id, ...permission };
                        }
                    }
                }).filter((permission) => permission)
            );
            setTableData(permissions);
        });
    };

    useEffect(() => {
        fetchPermissions();
    }, []);

    const onSelectPermission = (value) => {
        setSelPermissionId(value);
    };

    const addPermissionToConnectedApp = () => {
        if (!selPermissionId) {
            message.info(MarketPlaceStrings.SELECT_PERMISSION);
            return;
        }
        modifyPermission(props.connectedApp.id, selPermissionId, 'add').then((res) => {
            if (res) {
                setSelPermissionId(null);
                fetchPermissions();
            } else {
                message.error(ERROR_MSG.GENERAL_ERROR);
            }
        });
    };

    const deletePermission = (permissionId) => {
        modifyPermission(props.connectedApp.id, permissionId, 'delete').then((res) => {
            if (res) {
                fetchPermissions();
            } else {
                message.error(ERROR_MSG.GENERAL_ERROR);
            }
        });
    };

    return (
        <>
            <Row gutter={[16, 16]}>
                <Col span={21}>
                    <Select
                        {...catSelProp}
                        className="ns-width-full"
                        placeholder={'Select Permission'}
                        onSelect={onSelectPermission}
                        value={selPermissionId}
                    >
                        {options.map((option) => {
                            return (
                                <Option key={option.value} label={option.label} value={option.value}>
                                    <Row gutter={8}>
                                        <Col span={3}>
                                            <Text className="ns-white-space-break">{option.group_name}</Text>
                                        </Col>
                                        <Col span={19}>
                                            <Text type={ANTD_TEXT.TYPE_SECONDARY} className="ns-white-space-break">
                                                {option.permission_name}
                                            </Text>
                                        </Col>
                                        <Col span={2}>{option.risk_level}</Col>
                                    </Row>
                                </Option>
                            );
                        })}
                    </Select>
                </Col>
                <Col>
                    <Button type={ANTD_BUTTON.TYPE_PRIMARY} onClick={addPermissionToConnectedApp}>
                        Add Permission
                    </Button>
                </Col>
            </Row>
            <Table
                size={SIZE.SMALL}
                className="ns-margin-top"
                columns={permissionHistoryCol}
                dataSource={tableData}
                loading={loading}
                pagination={false}
                scroll={{ y: 500 }}
            />
        </>
    );
};

const ConnectedAppsFormFields = (props) => {
    const form = props.form;
    const disabledFields = props?.disabledFields ?? [];
    const saasAppIdFieldValue = Form.useWatch('saas_appid', form);
    const rule = props.rule;
    const formItemStyles = { marginBottom: 'unset' };
    const catSelProp = {
        showSearch: true,
        options: CategoryList,
        optionFilterProp: 'label',
        filterOption: (input, option) => option?.label?.toLowerCase().indexOf(input.toLowerCase()) >= 0,
        filterSort: (optionA, optionB) => optionA?.label?.toLowerCase().localeCompare(optionB?.label?.toLowerCase()),
    };

    const [modalOpen, setModalOpen] = useState(false);
    const [logoModalOpen, setLogoModalOpen] = useState(false);
    const [appLogo, setAppLogo] = useState(props.form.getFieldValue(ConnectedAppFields.app_logo_url));
    const [favIcon, setFavIcon] = useState(props.form.getFieldValue(ConnectedAppFields.fav_icon_logo_url));
    const [uploadedLogoUrl, setUploadedLogoUrl] = useState(COMMON_STRING.BLANK);

    useEffect(() => {
        setAppLogo(props.form.getFieldValue(ConnectedAppFields.app_logo_url));
        setFavIcon(props.form.getFieldValue(ConnectedAppFields.fav_icon_logo_url));
    }, [saasAppIdFieldValue]);

    const onSelectSaasApp = (appId) => {
        form.setFieldValue('saas_appid', appId);
        setModalOpen(false);
    };

    const onChangeLogo = (info) => {
        if (info.file.status === COMMON_STRING.DONE) {
            if (info?.file?.response?.success) {
                setUploadedLogoUrl(info?.file?.response?.data?.url);
            } else {
                message.error(ERROR_MSG.GENERAL_ERROR);
            }
        }
        if (info.file.status === COMMON_STRING.ERROR) {
            message.error(ERROR_MSG.UPLOAD_ERROR);
        }
    };

    return (
        <>
            <Row gutter={[16, 0]}>
                <Col span={5}>
                    <DividerComponent text={'App Name'} />
                    <Form.Item name={ConnectedAppFields.connected_app_name} rules={rule} style={formItemStyles}>
                        <Input disabled={disabledFields.includes(ConnectedAppFields.connected_app_name)} />
                    </Form.Item>
                    <DividerComponent text={'Display Name'} />
                    <Form.Item name={ConnectedAppFields.display_name} rules={rule} style={formItemStyles}>
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={10}>
                    <Row gutter={[8, 0]}>
                        <Col span={12}>
                            <DividerComponent text={'Publisher Name'} />
                            <Form.Item name={ConnectedAppFields.publisher_name} style={formItemStyles}>
                                <Input className='ns-width-full' />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <DividerComponent text={'Category'} />
                            <Form.Item name={ConnectedAppFields.category_id} rules={rule} style={formItemStyles}>
                                <Select {...catSelProp}></Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <div>
                        <DividerComponent text={'Publisher URL'} />
                        <Form.Item name={ConnectedAppFields.publisher_url} rules={rule} style={formItemStyles}>
                            <Input className='ns-width-full' />
                        </Form.Item>
                    </div>
                </Col>
                <Col span={5}>
                    <DividerComponent text={'Description'} />
                    <Form.Item name={ConnectedAppFields.description} rules={FormFieldRules.description} style={formItemStyles}>
                        <TextArea className='ns-width-full' rows={4} />
                    </Form.Item>
                </Col>
                <Col>
                    <DividerComponent text={'Saas App'} />
                    <Form.Item name={ConnectedAppFields.saas_appid} rules={rule} style={formItemStyles}>
                        <Search onSearch={() => setModalOpen(true)} enterButton />
                    </Form.Item>
                    <DividerComponent text={'Mp App Id'} />
                    <Form.Item name={ConnectedAppFields.mp_appid} style={formItemStyles}>
                        <Input className='ns-width-full' />
                    </Form.Item>
                </Col>
            </Row>
            {saasAppIdFieldValue == 0 ? (
                <Row align='middle'>
                    <Col span={8}>
                        <div>
                            <DividerComponent text={'Logo URL'} />
                            <Row>
                                <Col span={21}>
                                    <Form.Item name={ConnectedAppFields.app_logo_url} rules={rule} style={formItemStyles}>
                                        <Input
                                            className='ns-width-full'
                                            onChange={(e) => {
                                                setAppLogo(e.target.value);
                                            }}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={2}>
                                    <Button icon={<UploadOutlined />} onClick={() => setLogoModalOpen(true)}></Button>
                                </Col>
                            </Row>
                        </div>
                        <div>
                            <DividerComponent text={'Fav Icon URL'} />
                            <Form.Item name={ConnectedAppFields.fav_icon_logo_url} rules={rule} style={formItemStyles}>
                                <Input
                                    className='ns-width-full'
                                    onChange={(e) => {
                                        setFavIcon(e.target.value);
                                    }}
                                />
                            </Form.Item>
                        </div>
                    </Col>
                    <Col span={12}>
                        <Row justify='space-around' align={'middle'}>
                            <Col span={7}>
                                <Image preview={false} src={appLogo} />
                            </Col>
                            <Col span={1} offset={1}>
                                <Divider type='vertical' style={{ height: '50px', backgroundColor: 'grey' }} />
                            </Col>
                            <Col span={3} offset={1}>
                                <Image preview={false} src={favIcon} />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            ) : null}
            <Modal
                title={MarketPlaceStrings.SEARCH_SAAS_MODAL_TITLE}
                open={modalOpen}
                onCancel={() => setModalOpen(false)}
                footer={null}
                width={'80%'}
                destroyOnClose
            >
                <SearchSaasApp onSelectSaasApp={onSelectSaasApp} />
            </Modal>
            <Modal title={'Upload Logo'} open={logoModalOpen} onCancel={() => setLogoModalOpen(false)} width={'70%'} destroyOnClose>
                <Space size={16} align={ANTD_SPACE.ALIGN_CENTER}>
                    <Upload action={apiUrl.uri1 + 'custom/uploadlogo'} name='logo' headers={{ Authorization: `Bearer ${getToken()}` }} onChange={onChangeLogo} showUploadList={false}>
                        <Button icon={<UploadOutlined />}>Click to Upload</Button>
                    </Upload>
                    {uploadedLogoUrl === COMMON_STRING.BLANK ? COMMON_STRING.BLANK : <Paragraph copyable>{uploadedLogoUrl}</Paragraph>}
                </Space>
            </Modal>
        </>
    );
};

const EditConnectedAppModal = (props) => {
    const rule = FormFieldRules.default;
    const connectedApp = props.connectedApp;

    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [initValues, setInitValues] = useState({
        ...connectedApp,
        app_logo_url: connectedApp?.ConnectedAppLogo?.app_logo_url,
        fav_icon_logo_url: connectedApp?.ConnectedAppLogo?.fav_icon_logo_url,
    });

    const onFinish = (values) => {
        if (values?.saas_appid) {
            if (!(!isNaN(parseFloat(values?.saas_appid)) && isFinite(values?.saas_appid))) {
                message.info(MarketPlaceStrings.SAAS_ID_NUMBER);
                return;
            }
        }
        setLoading(true);
        validateMarketPlace(values, props.marketPlace, MarketPlaceDataTypes.connectedApps.key, connectedApp.id).then((res) => {
            if (res) {
                saveConnectedApp(values);
            }
            setLoading(false);
        });
    };

    const saveConnectedApp = (values) => {
        setLoading(true);
        saveEditConnectedApp(values, props.marketPlace, connectedApp.id).then((res) => {
            if (res) {
                message.success(MarketPlaceStrings.SAVED_SUCCESS_MSG);
            }
            setLoading(false);
        });
    };

    return (
        <Form name="edit_connected_apps" form={form} onFinish={onFinish} autoComplete="off" size={SIZE.SMALL} initialValues={initValues}>
            <ConnectedAppsFormFields
                form={form}
                rule={rule}
                marketPlace={props.marketPlace}
                disabledFields={[ConnectedAppFields.connected_app_name]}
            />
            <Divider></Divider>
            <Space direction={'horizontal'}>
                <Button type={'primary'} htmlType={'submit'} loading={loading}>
                    Save
                </Button>
                <Button type={'dashed'} onClick={() => form.resetFields()}>
                    Reset
                </Button>
            </Space>
        </Form>
    );
};

const SearchSaasApp = (props) => {
    const searchSaasTableCol = [
        { title: 'Id', dataIndex: 'application_id', key: 'application_id', width: '5%' },
        { title: 'Application Name', dataIndex: 'application_name', key: 'application_name', width: '15%' },
        { title: 'Current Name', dataIndex: 'current_name', key: 'current_name', width: '15%' },
        {
            title: 'URL',
            dataIndex: 'url',
            key: 'url',
            render: (url) => (
                <a href={url} target={'_blank'}>
                    {url}
                </a>
            ),
        },
        { title: 'App Status', dataIndex: 'completionStatus', key: 'completionStatus', width: '20%' },
        {
            title: 'Action',
            dataIndex: 'application_id',
            key: 'action',
            width: '8%',
            render: (appId) => (
                <Button
                    type={ANTD_BUTTON.TYPE_PRIMARY}
                    onClick={() => {
                        props.onSelectSaasApp(appId);
                    }}
                >
                    Select
                </Button>
            ),
        },
    ];

    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);

    const onSearch = (value) => {
        if (!value && value.length === 0) {
            return;
        }
        setLoading(true);
        searchSaasApp(value).then((res) => {
            if (res) {
                setTableData(
                    res.map((row, index) => {
                        return {
                            ...row,
                            key: row.application_id,
                            url: row?.AppUrl?.url,
                            completionStatus: row?.ResearchData?.completionStatus,
                        };
                    })
                );
            }
            setLoading(false);
        });
    };
    return (
        <>
            <Search placeholder="Search by App Name/URL" enterButton="Search" size={SIZE.SMALL} onSearch={onSearch} allowClear />
            <Table
                className="ns-margin-top"
                loading={loading}
                size={SIZE.SMALL}
                key={'search_saas_table'}
                columns={searchSaasTableCol}
                dataSource={tableData}
                scroll={{ y: 400 }}
                pagination={false}
                bordered
            />
        </>
    );
};

const DividerComponent = (props) => {
    return (
        <Divider orientation={ANTD_DIVIDER.ORIENTATION_LEFT} className={'dividerSmall'}>
            {props.text}
        </Divider>
    );
};

export default MarketPlaceUI;
